import { dynamicSourceId, nativeSource } from "./TemplateDetector.ts";
import { getRemoteSnapshot } from '../cast/RemoteSession.ts';
import type { KeiyoushiRepository, RepoExtension, RepoSource } from "./KeiyoushiRepoParser.ts";
export interface RepositoryEntry {
  entryId: string;
  runtimeId: string;
  repository: string;
  extension: RepoExtension;
  source: RepoSource;
  nativeId?: string;
}
export function storedRepositoryEntries(): Record<string, RepositoryEntry[]> {
  const remote=getRemoteSnapshot();
  if(remote)return Object.fromEntries(remote.repositories.map(repo=>[repo.url,(remote.entries||[]).filter(entry=>entry.repository===repo.url)]));
  try {
    const value: unknown = JSON.parse(localStorage.getItem("yomiri_external_catalogs") ?? "{}");
    if (!value || typeof value !== "object" || Array.isArray(value)) return {};
    return Object.fromEntries(
      Object.entries(value)
        .filter(([key, rows]) => Array.isArray(rows))
        .map(([key, rows]) => [
          key,
          (rows as RepositoryEntry[]).filter(
            (row) =>
              row &&
              typeof row.entryId === "string" &&
              typeof row.runtimeId === "string" &&
              row.source &&
              typeof row.source.name === "string" &&
              typeof row.source.lang === "string" &&
              row.extension &&
              typeof row.extension.iconUrl === "string",
          ).map(row => { const id = row.source.connectorId || nativeSource(row.source, row.extension.pkg); return id ? {...row, nativeId:id, runtimeId:id} : row; }),
        ]),
    );
  } catch {
    return {};
  }
}
export async function flattenRepository(
  repo: KeiyoushiRepository,
  key = repo.url,
): Promise<RepositoryEntry[]> {
  const rows = await Promise.all(
    repo.extensions.flatMap((extension) =>
      extension.sources.map(async (source) => {
        const entryId = await dynamicSourceId(source, extension.pkg, repo.baseUrl);
        const nativeId = source.connectorId || nativeSource(source, extension.pkg);
        return {
          entryId,
          runtimeId: nativeId ?? entryId,
          repository: key,
          extension: { ...extension, sources: [] },
          source,
          ...(nativeId ? { nativeId } : {}),
        };
      }),
    ),
  );
  return [...new Map(rows.map((row) => [row.entryId, row])).values()];
}
export function saveRepositoryEntries(key: string, entries: RepositoryEntry[]): void {
  const all = storedRepositoryEntries();
  all[key] = entries;
  localStorage.setItem("yomiri_external_catalogs", JSON.stringify(all));
}
